import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";

import {
  GridRow,
  GridColumn,
  Carousel,
  Button,
  LazyImg,
} from "arv-reactcomponents";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import staticEndpoints from "../../../api/endPoints";

class ThumbNailCarousel extends PureComponent {
  constructor() {
    super();
    this.scroll = this.scroll.bind(this);
    this.renderItems = this.renderItems.bind(this);
    this.carouselSize = 3;
  }
  scroll(type, event) {
    event.preventDefault();
    const { index } = this.props;
    const newIndex = type === "next" ? index + 1 : index - 1;
    if (newIndex > -1 && newIndex < this.props.list.length) {
      this.props.setImageIndex(newIndex);
    }

    const gaLabel = type === "next" ? "bottom" : "top";
    Analytics.trackEvent({
      action: Event.action.IMAGE_CHANGE,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      label: gaLabel,
    });
  }
  renderItems = (item, index) => {
    const activeClass = index === this.props.index ? "is-active" : "";
    if (this.props.ProductLoader) {
      return (
        <div className={`nw-thumbnail-loader is-color-${index}`} key={index} />
      );
    }
    return (
      <div
        role="presentation"
        className={`nw-thumbnail-image ${index} ${activeClass}`}
        key={index}
      >
        <LazyImg
          className="nw-thumbnail-imagelazy"
          index={index}
          src={item.thumbnail}
          offset={300}
          onClick={() => {
            this.props.setImageIndex(index);
          }}
        />
      </div>
    );
  };
  render() {
    const { list, ProductLoader, index } = this.props;
    return (
      <Fragment>
        {ProductLoader ? (
          <GridRow className="nw-thumbnail-row">
            <GridColumn className="nw-pdp-vcarousel">
              <Carousel
                className="nw-pdp-thumbnail"
                index={0}
                items={["0", "1", "2"]}
                renderItems={this.renderItems}
              />
            </GridColumn>
          </GridRow>
        ) : (
          <Fragment>
            <GridRow className="nw-thumbnail-row">
              <GridColumn>
                <div className="nw-thumbnail-icons">
                  {list.length > 1 && (
                    <Button
                      disabled={index === 0}
                      className="nwc-btn-primary-txt nw-pdpthumbnailcarouselbutton"
                      onClick={e => this.scroll("prev", e)}
                    >
                      <i className="icomoon-arrow_top nw-pdpcarouselicon" />
                    </Button>
                  )}
                </div>
              </GridColumn>
            </GridRow>
            <GridRow className="nw-thumbnail-row">
              <GridColumn className="nw-pdp-vcarousel">
                <Carousel
                  className="nw-pdp-thumbnail"
                  index={index}
                  items={list}
                  renderItems={this.renderItems}
                />
              </GridColumn>
            </GridRow>
            <GridRow className="nw-thumbnail-row">
              <GridColumn>
                <div className="nw-thumbnail-icons">
                  {list.length > 1 && (
                    <Button
                      disabled={index === list.length - 1}
                      className="nwc-btn-primary-txt nw-pdpthumbnailcarouselbutton"
                      onClick={e => this.scroll("next", e)}
                    >
                      <i className="icomoon-arrow_bottom nw-pdpcarouselicon" />
                    </Button>
                  )}
                </div>
              </GridColumn>
            </GridRow>
          </Fragment>
        )}
      </Fragment>
    );
  }
}
ThumbNailCarousel.defaultProps = {
  ProductLoader: false,
  list: [
    {
      large: staticEndpoints.noImg,
      thumbnail: staticEndpoints.noImg,
    },
    {
      large: staticEndpoints.noImg,
      thumbnail: staticEndpoints.noImg,
    },
    {
      large: staticEndpoints.noImg,
      thumbnail: staticEndpoints.noImg,
    },
  ],
};
ThumbNailCarousel.propTypes = {
  ProductLoader: PropTypes.bool,
  index: PropTypes.number.isRequired,
  setImageIndex: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      large: PropTypes.string,
      thumbnail: PropTypes.string,
    }),
  ),
};

export default ThumbNailCarousel;



// WEBPACK FOOTER //
// ./src/component/PdpComponents/ThumbNailCarousel/index.js